import moment from "moment";
import i18n from "locales/i18n";
import { downloadCsv } from "utils/downloadCsv";
import { EVENT_TYPE_MAP } from "../../calendar/eventTypes";
import { MEETING_STATUS_META, Meeting } from "../types";

const tm = i18n.getFixedT(null, "meetings");

const headers = () => [
  tm("csv.customer"),
  tm("csv.phone"),
  tm("csv.type"),
  tm("csv.date"),
  tm("csv.from"),
  tm("csv.to"),
  tm("csv.status"),
  tm("csv.job"),
  tm("csv.total"),
];

const toRow = (m: Meeting): string[] => [
  m.customerName,
  m.customerPhone ?? "",
  EVENT_TYPE_MAP[m.type].label,
  moment(m.date, "YYYY-MM-DD").format("YYYY-MM-DD"),
  m.allDay ? tm("csv.all_day") : m.from,
  m.allDay ? "" : m.to,
  MEETING_STATUS_META[m.displayStatus].label,
  m.estimate?.estimateNumber ? `#${m.estimate.estimateNumber}` : m.title,
  m.estimate?.totalCost != null ? String(m.estimate.totalCost) : "",
];

// Serialize the given meetings to CSV and trigger a browser download.
export const exportMeetingsCsv = (meetings: Meeting[]): void =>
  downloadCsv(
    headers(),
    meetings.map(toRow),
    `meetings-${moment().format("YYYY-MM-DD")}.csv`,
  );
